import { ViewModel, View } from "binder"
import { ToolModelFromProducerEditorView } from "./toolModelFromProducerEditor-view"
import { IToolModelFromProducer } from "../IToolModelFromProducer";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ToolModel, ToolModelSelectorViewModel } from "../toolModelSelector-viewModel";
import { ToolProducer, ToolProducerSelectorViewModel } from "../toolProducerSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ToolModelFromProducerEditorViewModel extends ViewModel implements IToolModelFromProducer, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.toolModelSelector = new ToolModelSelectorViewModel(this);
        this.toolModelSelector.onSelectionChanged = x => this.onToolModelChanged(x);
        this.toolProducerSelector = new ToolProducerSelectorViewModel(this);
        this.toolProducerSelector.onSelectionChanged = x => this.onToolProducerChanged(x);
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolModelFromProducerEditorView();
    }
    public getTypeId(): string {
        return "VM-7C2A4B99-6E79-4F50-AB9C-2CACCBF03565"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelSelector(v: ToolModelSelectorViewModel) { this._toolModelSelector = v; } public get toolModelSelector(): ToolModelSelectorViewModel { return this._toolModelSelector; } private _toolModelSelector: ToolModelSelectorViewModel;
    public set toolProducerId(v: string) { this._toolProducerId = v; } public get toolProducerId(): string { return this._toolProducerId; } private _toolProducerId: string;
    public set toolProducerSelector(v: ToolProducerSelectorViewModel) { this._toolProducerSelector = v; } public get toolProducerSelector(): ToolProducerSelectorViewModel { return this._toolProducerSelector; } private _toolProducerSelector: ToolProducerSelectorViewModel;

    closePopup(result?: any) {

    }

    onToolModelChanged(toolModel: ToolModel) {
        this.toolModelId = toolModel?.id;
    }
    onToolProducerChanged(toolProducer: ToolProducer) {
        this.toolProducerId = toolProducer?.id;
    }

    setToolModelId(id: string) {
        this.toolModelSelector.selectById(id);
    }
    getToolModelId(): string {
        return this.toolModelSelector.selectedItem?.id;
    }

    setToolProducerId(id: string) {
        this.toolProducerSelector.selectById(id);
    }
    getToolProducerId(): string {
        return this.toolProducerSelector.selectedItem?.id;
    }

    async cloneTo(toolModelFromProducer: IToolModelFromProducer) {
        toolModelFromProducer.id = this.id;
        toolModelFromProducer.setToolModelId(this.getToolModelId());
        toolModelFromProducer.setToolProducerId(this.getToolProducerId());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت سازنده مدل ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('سازنده مدل ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت سازنده مدل ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getToolModelId())) {
            result.push('مدل ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getToolProducerId())) {
            result.push('سازنده ابزار مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(toolModelFromProducer: IToolModelFromProducer): Promise<any>;
}

export class ToolModelFromProducerInserter implements IServerUpdater {
    async execute(toolModelFromProducer: IToolModelFromProducer): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolModelFromProducerServices/CreateToolModelFromProducer', {
                ToolModelId: toolModelFromProducer.getToolModelId(),
                ToolProducerId: toolModelFromProducer.getToolProducerId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ToolModelFromProducerUpdater implements IServerUpdater {
    async execute(toolModelFromProducer: IToolModelFromProducer): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolModelFromProducerServices/UpdateToolModelFromProducer', {
                ToolModelFromProducerId: toolModelFromProducer.id,
                ToolModelId: toolModelFromProducer.getToolModelId(),
                ToolProducerId: toolModelFromProducer.getToolProducerId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
